<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="busy">
        <template v-slot:default="props">
            <pb-body banner-size="sm"
                     :banner-img="fileResourceUrl(bannerImage)"
                     :breadcrumbs="breadcrumbs"
                     page-title="TEAM">
                <template slot="body">
                    <b-container>
                        <b-row>
                            <b-col md="3" :key="employee.id" style="margin-bottom: 20px;"
                                   v-for="(employee) in employeeList">
                               <router-link :to="'/employee/' + employee.name">

                               <div class="employee">
                                    <img :src="fileResourceUrl(employee.image)" :alt="employee.name" />
                                    <div class="employee-info">
                                        {{employee.name}}<br/>
                                        {{employee.departmentName}}
                                    </div>
                                </div>
                               </router-link>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>

    import EmployeeApi from "@shared/_api/employee";
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'pb-team',
        data() {
            return {
                breadcrumbs: [{
                    text: "Team",
                    href: '/team'
                }],
                employeeList: [],
                bannerImage: null,
                busy: false
            }
        },
        mounted() {
            this.busy = true;
            Promise.all([EmployeeApi.fetchAll(), ContentAPI.fetchPageByName("team-page")])
                .then(([dataEmployee, dataTeamPage]) => {
                    this.employeeList = dataEmployee;
                    this.bannerImage = dataTeamPage.contentDataSet.banner.value;
                }).finally(() => {
                this.busy = false;
            });
        }
    }
</script>

<style lang="scss">
    .employee {
        display: table-cell;
        cursor: pointer;
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#d7d7d7+0,f1f1f1+100 */
        background: rgb(215, 215, 215); /* Old browsers */
        background: -moz-linear-gradient(top, rgba(215, 215, 215, 1) 0%, rgba(241, 241, 241, 1) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(215, 215, 215, 1) 0%, rgba(241, 241, 241, 1) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(215, 215, 215, 1) 0%, rgba(241, 241, 241, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#d7d7d7', endColorstr='#f1f1f1', GradientType=0); /* IE6-9 */
        height: 245px;
        vertical-align: bottom;

        img {
            width: 100%;
            object-fit: contain;
        }
    }

    .employee-info {
        transition: all .5s ease-out;
        position: absolute;
        opacity: 0;
        bottom: 15px;
        left: 40px;
        color: #FFFFFF;
        font-family: "Roboto";
        font-size: 22px;
        font-weight: 300;
        letter-spacing: 1.47px;
        line-height: 29px;
        text-shadow: 0 2px 16px #000000;
    }

    .employee:hover {
        .employee-info {
            transition: all .5s ease-out;
            opacity: 100;
            display: block;
        }
    }
</style>